__turbopack_context__.v({
  "className": "inter_11880689-module__ut0pcq__className",
  "variable": "inter_11880689-module__ut0pcq__variable",
});
